export default __webpack_public_path__ + "static/media/lootbox-3.0dce1f91.png";